import { showDialog } from '@components/Dialog'
import { fileApi } from '@atheneum/api'

function confirmDelete (
  fileId,
  deleteAction = fileApi.deleteFile,
  title = 'Delete file?',
  text = "You won't be able to revert this!"
) {
  return showDialog({
    title,
    text,
    type: 'warning',
    showCancelButton: true
  }).then(() => deleteAction(fileId))
}

export default confirmDelete
